"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResultObject = createResultObject;
exports.convertToError = convertToError;
exports.validateComponent = validateComponent;
function createResultObject(html, consoleReplayScript, renderState) {
    return {
        html,
        consoleReplayScript,
        hasErrors: renderState.hasErrors,
        renderingError: renderState.error && { message: renderState.error.message, stack: renderState.error.stack },
        isShellReady: 'isShellReady' in renderState ? renderState.isShellReady : undefined,
    };
}
function convertToError(e) {
    return e instanceof Error ? e : new Error(String(e));
}
function validateComponent(componentObj, componentName) {
    if (componentObj.isRenderer) {
        throw new Error(`Detected a renderer while server rendering component '${componentName}'. See https://github.com/shakacode/react_on_rails#renderer-functions`);
    }
}
